<template>
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <li class="page-item" :class="hasPrev"><a class="page-link prev" @click.prevent="changePage(pageIndex-1)"><i class="icon-i-prev"></i></a></li>
      <li class="page-item" v-if="hasPagination" v-for="(page,i) in pageNumber" :class="disabledPage(page.value)" v-bind:key="i"><a class="page-link" v-bind:class="{'active': page.value === pageIndex}" @click.prevent="changePage(page.value)">{{page.text}}</a></li>
<li class="page-item" :class="hasNext"><a class="page-link next" @click.prevent="changePage(pageIndex+1)"><i class="icon-i-next"></i></a></li>
    </ul>
  </nav>
</template>
<script>

export default {
  props: {
    totalPages: 0,
    pageIndexNo: ''
  },
  data () {
    return {
      pageIndex: this.pageIndexNo
    }
  },
  computed: {
    show () {
      return this.totalPages > 0
    },
    hasPagination () {
      return this.pageNumber.length > 1
    },
    hasPrev () {
      return (this.pageIndex === 1) ? 'page-item-disabled' : ''
    },
    hasNext () {
      return this.pageIndex === this.totalPages ? 'page-item-disabled' : ''
    },
    pageNumber () {
      const arr = []
      if (this.totalPages === 1) {
        return arr
      }
      const start = 1
      const end = this.totalPages
      const showPageCount = 6
      if (end <= showPageCount + 3) {
        for (let i = start; i <= end; i++) {
          arr.push({text: i, value: i})
        }
        return arr
      }
      arr.push({ text: start, value: start, show: '' })
      if (this.pageIndex >= 5) {
        arr.push({
          text: '...',
          value: '',
          show: 1
        })
      }
      let listStart = this.pageIndex - Math.floor(showPageCount / 2) + 1
      if (listStart <= 1) listStart = 2
      let listEnd = listStart + showPageCount - 1
      if (listEnd >= end) listEnd = end - 1
      listStart = listEnd - showPageCount + 1
      for (let i = listStart; i <= listEnd; i++) {
        arr.push({ text: i, value: i })
      }
      if (end - this.pageIndex >= showPageCount) {
        arr.push({
          text: '...',
          value: '',
          show: 2
        })
      }
      arr.push({ text: end, value: end, show: '' })
      arr.map((e, index) => {
        if (e.text === '...' && e.show === 2) {
          e.value = arr[index - 1].value + 1
        }
        if (e.text === '...' && e.show === 1) {
          e.value = arr[index + 1].value - 1
        }
        return e
      })
      return arr
    }
  },
  methods: {
    disabledPage (value) {
      return value === this.pageIndex ? 'page-item-disabled' : ''
    },
    changePage (pageIndex) {
      this.pageIndex = pageIndex
      this.$emit('changePage', pageIndex)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/Pagination.vue